/* eslint-disable */
import { createContext, useState } from 'react';

const LoginContext = createContext({
  userAuthority: '로그인X',
  userInfo: {
    name: '',
    authList: [],
  },

  loginProcess: () => {},
});

const LoginProvider = ({ children }) => {
  const [userAuthority, setUserAuthority] = useState('로그인X');
  const [userInfo, setUserInfo] = useState({
    name: '',
    authList: [],
  });

  const loginProcess = grade => {
    setUserAuthority(grade);
  };

  return (
    <LoginContext.Provider
      value={{
        userAuthority,
        userInfo,
        setUserInfo,
        loginProcess,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export { LoginContext, LoginProvider };
